import {
  PlanPackageComponentDetails,
  SubscriptionDetails,
} from "features/types";
import { getPlanType } from "./planPackageUtils";
import { uniqBy } from "lodash";

export const getSubsByPlanType = (
  subscriptions: SubscriptionDetails[],
  type: PlanPackageComponentDetails["type"]
): SubscriptionDetails[] => {
  if (!subscriptions) return [];
  return subscriptions.filter(
    (sub) =>
      sub.planPackage.primaryComponent.type === type &&
      sub.expired === false &&
      sub.operative
  );
};
export const isNotPendingGift = (sub: SubscriptionDetails) => {
  if (sub.gift && sub.gift.claimed === false) {
    return false;
  }
  return true;
};

export const filterIneligibleSubscriptions = (sub: SubscriptionDetails) => {
  return !sub.expired && isNotPendingGift(sub);
};

export const getUniqSubscriptions = (
  subscriptions: SubscriptionDetails[],
  extraConditions?: (sub: SubscriptionDetails) => boolean
): SubscriptionDetails[] => {
  const activeSubscriptions = subscriptions.filter((sub) => {
    if (extraConditions) {
      return filterIneligibleSubscriptions(sub) && extraConditions(sub);
    } else {
      return filterIneligibleSubscriptions(sub);
    }
  });
  // sort subscriptions by id
  return uniqBy(activeSubscriptions, "planPackage.id").sort(
    (a, b) => a.id - b.id
  );
};

export const sortVoucherSubsByUnusedVouchers = (
  a: SubscriptionDetails,
  b: SubscriptionDetails
) => {
  if (
    getPlanType(a.planPackage) !== "VOUCHER" ||
    getPlanType(b.planPackage) !== "VOUCHER"
  ) {
    return 1;
  }
  if (b.availableVouchers === 0) return -1;
  return 0;
};
